<template>
    <v-container fluid>
        <v-data-table
            :headers="headers"
            :items="pagedItems"
            class="elevation-0"
            :mobile-breakpoint="0"
            :loading="loading"
            disable-pagination
            hide-default-footer
        >
            <template v-slot:top>
                <div class="top">
                    <v-row
                        no-gutter
                        class="mt-0 mx-0 pt-4 pb-0 pb-4"
                        :style="{ 'background-color': '#eeeeee' }"
                    >
                        <h1 class="mr-4 ml-4">SHIPPING</h1>
                        <v-spacer />
                        <v-btn
                            @click="downloadTemplate"
                            color="primary"
                            class="d-flex align-center mr-4"
                            rounded
                            :disabled="loading"
                        >
                            {{
                                $vuetify.breakpoint.smAndDown ? '' : 'TEMPLATE'
                            }}
                            <v-icon class="ml-1">mdi-download</v-icon>
                        </v-btn>
                        <v-btn
                            @click="importFiles"
                            color="primary"
                            class="d-flex align-center mr-4"
                            rounded
                            :disabled="loading"
                        >
                            {{ $vuetify.breakpoint.smAndDown ? '' : 'IMPORT' }}
                            <v-icon class="ml-1">mdi-import</v-icon>
                        </v-btn>
                    </v-row>
                </div>
            </template>
            <!--HEADERS-->
            <template v-slot:[`header.country`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByCountry"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <template v-slot:[`header.state`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByState"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <template v-slot:[`header.city`]="{ header }">
                <v-text-field
                    class="pb-2 pt-3 mt-2"
                    :label="header.text"
                    v-model="searchByCity"
                    dense
                    prepend-icon="mdi-filter"
                />
            </template>
            <!--ITEMS-->
            <template v-slot:[`item.country`]="{ item }">
                <div class="d-flex">
                    <p class="my-0  pl-8">{{ item.country }}</p>
                </div>
            </template>
            <template v-slot:[`item.state`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.state }}</p>
                </div>
            </template>
            <template v-slot:[`item.city`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">{{ item.city }}</p>
                </div>
            </template>
            <template v-slot:[`item.shippingCost`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ formatNumber(item.shippingCost) }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.internalShipping`]="{ item }">
                <div class="d-flex justify-center">
                    <p class="my-0">
                        {{ formatNumber(item.internalShipping) }}
                    </p>
                </div>
            </template>
            <template v-slot:[`item.actions`]="{ item }">
                <div class="d-flex justify-center">
                    <v-btn small icon @click="editItem(item)">
                        <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                </div>
            </template>
            <!-- FOOTER -->
            <template v-slot:[`body.append`]>
                <tr :style="{ 'background-color': '#eeeeee' }">
                    <td :colspan="headers.length">
                        <v-row
                            class="pa-4 d-flex align-center justify-space-between"
                        >
                            <v-select
                                v-model="itemsPerPage"
                                :items="[10, 20, 50, 100]"
                                label="Items per page"
                                dense
                                outlined
                                hide-details
                                style="max-width: 150px"
                            />
                            <v-pagination
                                v-model="page"
                                :length="pageCount"
                                total-visible="7"
                                color="primary"
                            />
                        </v-row>
                    </td>
                </tr>
            </template>
        </v-data-table>
        <v-dialog
            v-model="openItemFiles"
            persistent
            max-width="600px"
            :retain-focus="false"
        >
            <v-card :loading="loading" v-if="openItemFiles">
                <v-card-title class="text-h5">
                    <v-btn
                        small
                        icon
                        @click="closeImportFiles"
                        color="primary"
                        class="ml-n3 mr-2"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    Upload Shipping File
                </v-card-title>
                <v-divider class="ml-4 mr-5" />
                <v-card-text>
                    <v-form v-model="valid" class="mt-2 mb-0">
                        <v-row no-gutters>
                            <v-col cols="12">
                                <v-file-input
                                    chips
                                    label="File Input"
                                    v-model="file"
                                    :rules="[rules.required]"
                                    required
                                    prepend-icon="mdi-paperclip"
                                    accept=".xls,.xlsx"
                                ></v-file-input>
                            </v-col>
                        </v-row>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-spacer />
                    <v-btn
                        rounded
                        color="primary"
                        class="mb-5 mt-n4"
                        @click="readXLSX"
                        :disabled="!valid"
                        :loading="loading"
                    >
                        ADD FILE
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            max-width="600px"
            :retain-focus="false"
            v-model="openDialog"
            persistent
        >
            <ShippingForm
                v-if="openDialog"
                :setting="setting"
                :createForm="false"
                :originalShipping="selectedItem"
                :items="items"
                :editSettingPermission="editSettingPermission"
                @close="closeDialog"
                @replaceShipping="replaceShipping"
            />
        </v-dialog>
        <CustomLocationsSection
            :setting="setting"
            :edit-setting-permission="editSettingPermission"
        />
    </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import API from '@/services/api'
import * as XLSX from 'xlsx'
import { storage } from '@/services/firebase'
import CustomLocationsSection from './CustomLocationsSection.vue'
const { v4: uuidv4 } = require('uuid')
import _ from 'lodash'

export default {
    name: 'Shipping',
    props: {
        setting: {
            type: Object,
            required: true,
        },
    },
    components: {
        ShippingForm: () => import('./ShippingForm.vue'),
        CustomLocationsSection,
    },
    data: () => ({
        loading: false,
        headers: [
            {
                text: 'COUNTRY',
                value: 'country',
                sortable: false,
                align: 'center',
            },
            {
                text: 'STATE',
                value: 'state',
                sortable: false,
                align: 'center',
            },
            {
                text: 'CITY',
                value: 'city',
                sortable: false,
                align: 'center',
            },
            {
                text: 'SHIPPING COST',
                value: 'shippingCost',
                sortable: false,
                align: 'center',
            },
            {
                text: 'INTERNAL SHIPPING',
                value: 'internalShipping',
                sortable: false,
                align: 'center',
            },
            {
                text: 'CURRENCY',
                value: 'currency',
                sortable: false,
                align: 'center',
            },
            {
                text: 'ACTIONS',
                value: 'actions',
                sortable: false,
                align: 'center',
            },
        ],
        items: [],
        searchByCountry: undefined,
        searchByState: undefined,
        searchByCity: undefined,
        openItemFiles: false,
        file: undefined,
        rules: {
            required: v => !!v || 'The value is required',
        },
        valid: false,
        companyId: JSON.parse(localStorage.getItem('company')),
        page: 1,
        itemsPerPage: 20,
        selectedItem: {},
        openDialog: false,
        editSettingPermission: false,
        formatFolder: 'shipping',
        formatName: 'Shipping_Format.xlsx',
    }),
    computed: {
        filters() {
            const conditions = []
            if (this.searchByCountry) {
                conditions.push(this.filterByCountry)
            }
            if (this.searchByState) {
                conditions.push(this.filterByState)
            }
            if (this.searchByCity) {
                conditions.push(this.filterByCity)
            }
            if (conditions.length > 0) {
                return this.items.filter(item => {
                    return conditions.every(condition => {
                        return condition(item)
                    })
                })
            }
            return this.items
        },
        filteredItems() {
            const conditions = []
            if (this.searchByCountry) {
                conditions.push(this.filterByCountry)
            }
            if (this.searchByState) {
                conditions.push(this.filterByState)
            }
            if (this.searchByCity) {
                conditions.push(this.filterByCity)
            }
            const filtered = conditions.length
                ? this.items.filter(item => conditions.every(c => c(item)))
                : this.items

            return filtered
        },
        pagedItems() {
            const start = (this.page - 1) * this.itemsPerPage
            const end = start + this.itemsPerPage
            return this.filteredItems.slice(start, end)
        },
        pageCount() {
            return Math.ceil(this.filteredItems.length / this.itemsPerPage)
        },
    },
    async mounted() {
        try {
            this.loading = true
            this.items = await API.getAllShipping(this.setting.id)
            const {
                data: { user },
            } = await API.getMyInfo()
            this.editSettingPermission = user.permissions.some(
                permission => permission === 'editSettings'
            )
        } catch (error) {
            this.setErrorItems({
                source: this.$options.name,
                message: error.message,
            })
        } finally {
            this.loading = false
        }
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        replaceShipping(items) {
            this.items = _.cloneDeep(items)
        },
        closeDialog() {
            this.openDialog = false
            this.selectedItem = {}
        },
        editItem(item) {
            this.selectedItem = _.cloneDeep(item)
            this.openDialog = true
        },
        formatNumber(number) {
            return new Intl.NumberFormat('de-DE', {
                maximumFractionDigits: 4,
            }).format(number || 0)
        },
        filterByCountry(item) {
            return item.country
                .toLowerCase()
                .includes(this.searchByCountry.toLowerCase())
        },
        filterByState(item) {
            return item.state
                .toLowerCase()
                .includes(this.searchByState.toLowerCase())
        },
        filterByCity(item) {
            return item.city
                .toLowerCase()
                .includes(this.searchByCity.toLowerCase())
        },
        importFiles() {
            this.openItemFiles = true
        },
        closeImportFiles() {
            this.openItemFiles = false
            this.valid = false
            this.file = undefined
        },
        // async downloadTemplate() {},
        async downloadTemplate() {
            try {
                this.loading = true

                const basePath = `${this.companyId}/${this.formatFolder}`
                const filename = this.formatName
                await this.downloadFileWithName(basePath, filename, filename)
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.loading = false
            }
        },
        async downloadFileWithName(filePath, fileId, filename) {
            // Get download URL from Firebase Storage
            const storageRef = storage().ref(filePath)
            const documentRef = storageRef.child(fileId)
            const downloadURL = await documentRef.getDownloadURL()

            // Download file with custom name
            const response = await fetch(downloadURL)
            const blob = await response.blob()
            const url = window.URL.createObjectURL(blob)
            const link = window.document.createElement('a')
            link.href = url
            link.download = filename
            window.document.body.appendChild(link)
            link.click()
            window.document.body.removeChild(link)
            window.URL.revokeObjectURL(url)
        },
        async readXLSX() {
            try {
                this.loading = true
                if (
                    this.file.name.endsWith('.xls') ||
                    this.file.name.endsWith('.xlsx')
                ) {
                    const allowedKeys = [
                        'Country',
                        'State',
                        'City',
                        'Shipping costs',
                        'Internal Shipping',
                        'Currency',
                    ]
                    const data = await this.file.arrayBuffer()
                    const workbook = XLSX.read(data)
                    const sheetName = workbook.SheetNames[0]
                    const headerRow =
                        XLSX.utils.sheet_to_json(workbook.Sheets[sheetName], {
                            header: 1,
                            range: 0,
                        })[0] || []
                    const missingColumns = allowedKeys.filter(
                        key => !headerRow.includes(key)
                    )
                    if (missingColumns.length > 0) {
                        throw new Error(
                            'The file does not contain the required columns'
                        )
                    }
                    const xlsData = XLSX.utils.sheet_to_json(
                        workbook.Sheets[sheetName],
                        {
                            header: allowedKeys,
                            raw: false,
                            defval: null,
                            range: 1,
                        }
                    )
                    this.sheetData = xlsData.map(row => ({
                        country: row.Country,
                        state: row.State,
                        city: row.City,
                        shippingCost: this.parseCurrency(row['Shipping costs']),
                        internalShipping: this.parseCurrency(
                            row['Internal Shipping']
                        ),
                        currency: row.Currency.trim(),
                        id: uuidv4(),
                    }))
                    const blob = new Blob([JSON.stringify(this.sheetData)], {
                        type: 'application/json',
                    })
                    const path = `${this.companyId}/shipping/shippingData.json`
                    const storageRef = storage().ref(path)
                    await storageRef.put(blob)
                    this.items = this.sheetData
                } else {
                    throw new Error('Unsupported file format')
                }
            } catch (error) {
                this.setErrorItems({
                    source: this.$options.name,
                    message: error.message,
                })
            } finally {
                this.closeImportFiles()
                this.loading = false
            }
        },
        parseCurrency(value) {
            if (typeof value !== 'string') return parseFloat(value) || null
            const cleaned = value.replace(/[^\d.-]/g, '').replace(/,/g, '')
            return parseFloat(cleaned) || null
        },
        chunkArray(array, size) {
            const result = []
            for (let i = 0; i < array.length; i += size) {
                result.push(array.slice(i, i + size))
            }
            return result
        },
    },
}
</script>

<style>
thead {
    position: sticky;
    z-index: 2;
}
</style>
